import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../News/AwsNews.css";
import aws_success from "../../assets/images/aws_success.png";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";

const AwsNewsPage = () => {
    return (
        <div>
            <Helmet>
                <title>Idexcel Achieves AWS Agentic AI Competency</title>
                <meta
                    content="Idexcel Achieves AWS Agentic AI Competency"
                    name="keywords"
                />
                <meta
                    content="Read our latest AWS Agentic AI Competence News to learn how Idexcel helped clients transform their businesses and stay at the top of our ever-changing industry."
                    name="description"
                />
            </Helmet>
            <motion.div
                className="Productright"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
                viewport={{ once: true, amount: 0.3 }}
            >
                <Container fluid className="aws-banner-container p-0">
                    <section className="aws-banner-section"></section>
                </Container>
            </motion.div>

            <section className="aws-stories-section ">
                <Container className="my-5 px-xl-5" style={{ textAlign: "justify" }}>
                    {/* <h2 className="text-center mb-4 section-title">
                        <span className="textgrad"> Success</span> Stories
                    </h2> */}
                    {/* <h4
                        className="text-black mb-5 text-left"
                        style={{ lineHeight: "unset" }}
                    >
                        <span className="fw-semibold"> AWS Partner Story:</span> Idexcel
                        Manages and Maintains Cync Software's flagship product "Cync
                        Application Suite" on Amazon Web Services Infrastructure
                    </h4> */}
                    <section>
                        {/* <h4 className="fw-semibold">About Cync Software</h4> */}
                        <p className="pt-2 m-0  mb-2">
                            {/* <a
                                style={{ padding: "inherit" }}
                                className="text-danger textDecoration"
                                target="_blank"
                                href="https://www.ndsapps.com/"
                            >
                                NDS Systems
                            </a> */}
                            {/* <b>Herndon, Virginia, January 20, 2026:</b> */}
                            Idexcel has achieved the Amazon Web Services (AWS) Agentic AI Competency, recognizing our expertise in designing and delivering agentic AI solutions that automate complex processes, accelerate decision-making, and improve operational efficiency.

                        </p>

                        <p className="pt-2 m-0  mb-2">
                            {/* <a
                                style={{ padding: "inherit" }}
                                className="text-danger textDecoration"
                                target="_blank"
                                href="https://www.ndsapps.com/"
                            >
                                NDS Systems
                            </a> */}
                            {/* <b>Herndon, Virginia, January 20, 2026:</b> */}
                            This achievement reflects our commitment to moving organizations beyond AI experimentation, building intelligent agents that reason, plan, and take action across business workflows. By combining deep domain expertise with AWS technologies, we enable organizations to deploy scalable, secure, and responsible AI at enterprise speed.

                        </p>
                    </section>
                    <section className="mt-4">
                        <h4 className="fw-semibold fs-3">Unlocking the Value of Agentic AI </h4>
                        <p className=" m-0 ">
                            Agentic AI is changing how work gets done. Intelligent agents collaborate with employees, automate multi-step tasks, and integrate with enterprise applications to streamline operations and improve performance. Idexcel partners with organizations to identify high-value opportunities and build solutions aligned with their strategic goals.
                        </p>
                    </section>
                    <section className="mt-4">
                        <h4 className="fw-semibold fs-3">How Idexcel Delivers Business Value</h4>
                        <p className=" m-0 ">
                            Idexcel drives measurable results through:
                        </p>
                        <ul
                            className="custom-orange-list fs-5"
                            style={{
                                listStyleType: "disc",
                                paddingLeft: "2.8rem",
                            }}
                        >
                            <li className="mb-2">Automating complex, multi-step workflows</li>
                            <li className="mb-2">Enhancing customer and employee experiences</li>
                            <li className="mb-2">Integrating AI seamlessly with existing enterprise systems</li>
                            <li>Delivering secure, governed AI built for responsible scale</li>
                        </ul>
                        <Container fluid className="bg-grey px-0">
                            <Container className="aws-orange-side-borders">
                                <Row className="p-0 m-0 bg-grey content  pt-xl-3 pb-2">
                                    <Container className="px-0  ">
                                        <section className="ck-custom-singleblog-post px-0 px-lg-3 pt-1 pb-3">
                                            <blockquote className="ck-custom-singleblog-post-content">
                                                <p>
                                                    “Everyone is talking about Agentic AI, but success isn't about building intelligent agents alone. It requires governance, security, trusted data, orchestration, and human oversight. At Idexcel, we help organizations move from AI experiments to production-ready Agentic AI that delivers measurable business outcomes.”
                                                </p>
                                                <p className="d-flex align-items-center gap-3 mt-3 mb-0">
                                                    <strong className="author-name">
                                                        Prasad Alapati, CEO and President, Idexcel
                                                    </strong>
                                                </p>
                                            </blockquote>
                                        </section>
                                    </Container>
                                </Row>
                            </Container>
                        </Container>

                    </section>

                    <section className="mt-4">
                        <h4 className="fw-semibold fs-3">Start Your Agentic AI Journey</h4>
                        <p className=" m-0 ">
                            Whether you're exploring your first AI agent or scaling enterprise-wide adoption, Idexcel is ready to design, implement, and optimize intelligent solutions built for real business outcomes.
                        </p>

                    </section>
                    <p style={{ margin: '10px 0 12px 0' }}>

                        <a href="https://www.idexcel.com/contact-us"
                            style={{ color: '#1a73e8', textDecoration: 'none', fontWeight: 'semibold' }} >
                            Talk to our AI experts
                        </a>{' '}
                        and discover how agentic AI can transform your business.
                    </p>
                    {/* <div className="text-center mt-4">
                        <div className="text-center mt-4">
                            <button
                                onClick={() => (window.location.href = "/contact-us")}
                                style={{
                                    backgroundColor: "#f06319",
                                    border: "none",
                                    borderRadius: "10px",
                                    padding: "16px 24px 10px 24px",
                                    color: "#fff",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    fontWeight: "700",
                                }}
                            >
                                TALK TO OUR AI EXPERTS
                            </button>
                        </div>
                    </div> */}
                </Container>
            </section>
            {/* <Container fluid className="bg-grey orange-side-borders">
                <Row className="p-0 m-0 bg-grey content px-xl-5 pt-xl-5 pb-5">
                    <Container className="px-3 px-xl-2 px-lg-0">
                        <section className="ck-custom-singleblog-post px-0 px-lg-5 pt-1 pb-3">
                            <blockquote className="ck-custom-singleblog-post-content">
                                <p>
                                    “Achieving the AWS AI Services Competency underscores our responsibility to help customers apply AI with clarity and purpose.”
                                </p>

                                <p className="d-flex align-items-center gap-3 mt-3 mb-0">

                                    <strong>
                                        Allolankandy Anand, Vice President -Digital Transformation & Strategy at Idexcel.
                                    </strong>
                                </p>
                            </blockquote>
                        </section>
                    </Container>
                </Row>
            </Container> */}

        </div >
    );
};

export default AwsNewsPage;
